import { useTranslation } from "react-i18next";
import { Contract } from "@/types";
import { usePaymentForCompany } from "@/hooks/usePaymentForCompany";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import NumberFormatter from "@/components/atoms/NumberFormatter";

interface Props {
  contract: Contract;
}

// The contract price worded from the current company's own side, e.g. "You pay 7 000 NOK per ton". The owner sees
// both sides in BuyerAndSellerPriceLabels instead.
function PaymentForCompanyLabel({ contract }: Props) {
  const { t } = useTranslation();
  const { labelKey, price, suffix } = usePaymentForCompany(contract);

  return (
    <Stack>
      <Text size="sm" color="secondary" data-testid="payment-label">
        {t(labelKey)}
      </Text>
      <Text size="lg">
        <NumberFormatter data-testid="payment-price" value={price} suffix={` ${suffix}`} />
      </Text>
    </Stack>
  );
}

export default PaymentForCompanyLabel;
